import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcResponseById,
    setCcResponseEdit,
    setCcResponseReloadEdit,
    initCcResponse,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface ReponseEditProps {
    responseId: number
    module: number
}

const Edit = ({
    responseId,
    module,
}: ReponseEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const response = useSelector((state: StoreType) => state.ccResponse.responseEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccResponse.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcResponseReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcResponseReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (responseId === 0) {
            dispatch(setCcResponseEdit(initCcResponse))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcResponseById(responseId, userData.accountId, project.id).then((res) => {
                dispatch(setCcResponseEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!response) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{response.id ? `${lang.editResponse} #${response.id}` : lang.addResponse}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form response={response} module={module} />
                }
                {
                    reloadEdit
                    && <Form response={response} module={module} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
